import ProductDraftSlate from './ProductDraftSlate'

export default ProductDraftSlate
